import React, { useRef, useState } from 'react';
import { useAuth } from '../../context/AuthContext';
import { Camera, X, FileText } from 'lucide-react';
import { toast } from 'sonner';

const API = process.env.REACT_APP_BACKEND_URL;

export const PhotoUploader = ({ furnitureId, uploadUrl, photos, onChange, label = 'Fotos', accept = 'image/*', testId = 'photo-uploader' }) => {
  const { authFetch } = useAuth();
  const inputRef = useRef(null);
  const [uploading, setUploading] = useState(false);
  const endpoint = uploadUrl || `/api/furniture/${furnitureId}/photos`;

  const upload = async (e) => {
    const files = Array.from(e.target.files || []);
    if (!files.length) return;
    setUploading(true);
    try {
      const refs = [];
      for (const file of files) {
        const fd = new FormData();
        fd.append('file', file);
        const res = await authFetch(endpoint, { method: 'POST', body: fd });
        if (!res.ok) throw new Error();
        refs.push(await res.json());
      }
      onChange([...(photos || []), ...refs]);
      toast.success(`${refs.length} archivo(s) subido(s)`);
    } catch { toast.error('Error al subir archivo'); }
    setUploading(false);
    if (inputRef.current) inputRef.current.value = '';
  };

  const remove = (id) => onChange((photos || []).filter(p => p.id !== id));

  return (
    <div data-testid={testId}>
      <label className="block text-xs font-medium tracking-wider uppercase mb-1.5" style={{ color: '#C9B8A8' }}>{label}</label>
      <div className="flex flex-wrap gap-2">
        {(photos || []).map(p => (
          <div key={p.id} className="relative group w-20 h-20 rounded-lg overflow-hidden border" style={{ borderColor: '#E8E3D8' }}>
            {p.is_image && p.thumb_url ? (
              <img src={`${API}${p.thumb_url}`} alt={p.filename} loading="lazy" className="w-full h-full object-cover" />
            ) : (
              <div className="w-full h-full flex flex-col items-center justify-center gap-1" style={{ backgroundColor: '#F5F3EF' }}>
                <FileText size={18} style={{ color: '#C9A66B' }} />
                <span className="text-[8px] px-1 truncate w-full text-center" style={{ color: '#C9B8A8' }}>{p.filename}</span>
              </div>
            )}
            <button type="button" onClick={() => remove(p.id)}
              className="absolute top-0.5 right-0.5 rounded-full p-0.5 opacity-0 group-hover:opacity-100 transition-opacity"
              style={{ backgroundColor: '#B87B7B', color: '#fff' }}>
              <X size={10} />
            </button>
          </div>
        ))}
        <button type="button" onClick={() => inputRef.current?.click()} disabled={uploading}
          data-testid={`${testId}-add-btn`}
          className="w-20 h-20 rounded-lg border border-dashed flex flex-col items-center justify-center gap-1 transition-colors disabled:opacity-50"
          style={{ borderColor: '#C9A66B', color: '#C9A66B' }}>
          <Camera size={18} />
          <span className="text-[9px]">{uploading ? 'Subiendo...' : 'Agregar'}</span>
        </button>
      </div>
      <input ref={inputRef} type="file" accept={accept} multiple className="hidden" onChange={upload} />
    </div>
  );
};

export const FURNITURE_STAGES = [
  'solicitud', 'levantamiento', 'ficha_tecnica', 'cotizacion_carpintero',
  'presupuesto_cliente', 'aprobacion_cliente', 'anticipo', 'fabricacion', 'instalacion',
];

export const FURNITURE_STAGE_LABELS = {
  solicitud: 'Solicitud',
  levantamiento: 'Levantamiento',
  ficha_tecnica: 'Ficha Técnica',
  cotizacion_carpintero: 'Cotización Carpintero',
  presupuesto_cliente: 'Presupuesto Cliente',
  aprobacion_cliente: 'Aprobación Cliente',
  anticipo: 'Anticipo',
  fabricacion: 'Fabricación',
  instalacion: 'Instalación y Entrega',
};

export const FURNITURE_STAGE_COLORS = {
  solicitud: '#C9B8A8', levantamiento: '#D4A574', ficha_tecnica: '#C9A66B',
  cotizacion_carpintero: '#B08D57', presupuesto_cliente: '#C9A66B',
  aprobacion_cliente: '#B87B7B', anticipo: '#8B9F8D', fabricacion: '#7B8FA8',
  instalacion: '#6B8F6B',
};
